export const ROUTES = {
    GAMES: '/v1/search'
};
